"use client";

import { DrawerHeader, DrawerTitle, IconButton } from "@dafiti/closet-ui";
import { Back, Close } from "@dafiti/closet-ui/icons";
import { useTranslations } from "next-intl";

type DrawerFiltersHeaderProps = {
  screen: "root" | "drill";
  facetLabel?: string;
  onBack: () => void;
  onClose: () => void;
};

export function DrawerFiltersHeader({
  screen,
  facetLabel,
  onBack,
  onClose,
}: DrawerFiltersHeaderProps) {
  const t = useTranslations("catalog");
  const isDrill = screen === "drill";
  const title = isDrill ? (facetLabel ?? "") : t("drawer.filters");

  return (
    <DrawerHeader
      className="flex items-center justify-between"
      data-testid="drawer-filters-header"
    >
      <div className="flex items-center gap-4">
        {isDrill && (
          <IconButton
            variant="subtle"
            size="md"
            onClick={onBack}
            aria-label={t("drawer.back")}
            data-testid="drawer-filters-header-back"
          >
            <Back aria-hidden="true" />
          </IconButton>
        )}

        <DrawerTitle
          className="truncate text-heading-5! font-bold text-gray-600"
          data-testid="drawer-filters-header-title"
        >
          {title}
        </DrawerTitle>
      </div>

      <IconButton
        variant="subtle"
        size="md"
        onClick={onClose}
        aria-label={t("drawer.closeFilters")}
        data-testid="drawer-filters-header-close"
      >
        <Close aria-hidden="true" />
      </IconButton>
    </DrawerHeader>
  );
}
